import { AppLayoutHeaderWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Header/HeaderWrapper";
import { NavigationMenuItemsDesktop } from "./Navigation/NavigationMenuItems";
import { AppLayoutWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Wrapper";
import { AppLayoutHeaderDesktop } from "./Header/AppLayoutHeader";
import { AppLayoutInnerWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/InnerWrapper";
import { AppLayoutPageWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/PageWrapper";
import { NavScrollPillWrapper } from "./Navigation/NavScrollPillWrapper";
import { NavigationMenuItemsWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItemsWrapper";
import { NavigationMenuSectionTitleDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuSectionTitle";
import { NavigationMenuItemDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItem";
import { RecentlyViewedSectionDesktop } from "@src/containers/redesign/AppLayout/Desktop/Navigation/RecentlyViewedSection";
import { AllRoutes } from "../Shared/Navigation/routes/AllRoutes";
import { CurrentlyViewedSectionDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/CurrentlyViewedSection";
import { useNavigationTranslationLabels } from "../Shared/Navigation/navigationMenu/translationLabels";
import { useRef } from "react";

export interface AppLayoutDesktopProps {
  admin: boolean;
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  userName: string;
  userId: string;
  logoutConfirm: () => void;
  logoutFromAllDevicesConfirm: () => void;
  showLogoutFromAllDevices: boolean;
  renderStartPage: () => JSX.Element | null;
}

export function AppLayoutDesktop(props: AppLayoutDesktopProps) {
  const {
    admin,
    isAdmin,
    isWorker,
    isWorkplace,
    userName,
    userId,
    logoutConfirm,
    logoutFromAllDevicesConfirm,
    showLogoutFromAllDevices,
    renderStartPage,
  } = props;
  const translationLabels = useNavigationTranslationLabels();
  const navScrollRef = useRef<HTMLDivElement>(null);

  return (
    <AppLayoutWrapperDesktop>
      <AppLayoutHeaderWrapperDesktop>
        <AppLayoutHeaderDesktop />
      </AppLayoutHeaderWrapperDesktop>
      <AppLayoutInnerWrapperDesktop>
        <NavScrollPillWrapper scrollContainerRef={navScrollRef}>
          <NavigationMenuItemsWrapperDesktop ref={navScrollRef}>
            <NavigationMenuItemsDesktop
              isAdmin={isAdmin}
              isWorker={isWorker}
              isWorkplace={isWorkplace}
            />
            <CurrentlyViewedSectionDesktop
              admin={admin}
              isWorker={isWorker}
              isWorkplace={isWorkplace}
              currentName={userName}
              currentUserId={userId}
            />
            <RecentlyViewedSectionDesktop admin={admin} />
            <NavigationMenuSectionTitleDesktop>
              {translationLabels.logOut}
            </NavigationMenuSectionTitleDesktop>
            <NavigationMenuItemDesktop
              iconType="door-straight"
              isSelected={false}
              onClick={() => {
                logoutConfirm();
              }}
            >
              {translationLabels.logOut}
            </NavigationMenuItemDesktop>
            {showLogoutFromAllDevices && (
              <NavigationMenuItemDesktop
                iconType="door-straight"
                isSelected={false}
                onClick={() => {
                  logoutFromAllDevicesConfirm();
                }}
              >
                {translationLabels.logOutFromAllDevices}
              </NavigationMenuItemDesktop>
            )}
          </NavigationMenuItemsWrapperDesktop>
        </NavScrollPillWrapper>
        <AppLayoutPageWrapperDesktop>
          <AllRoutes
            admin={admin}
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            renderStartPage={renderStartPage}
          />
        </AppLayoutPageWrapperDesktop>
      </AppLayoutInnerWrapperDesktop>
    </AppLayoutWrapperDesktop>
  );
}
